import React, { useCallback } from 'react';
import { TouchableHighlight, View } from 'react-native';
import { rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import EmojiText from 'design-system/EmojiText';
import { CIRCLE_SIZE } from 'design-system/LogoBankAccount';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { getBalanceForPots } from 'utils/api/getBalance';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconBoldAdd } from 'design-system/icons/IconBoldAdd';
import { IconBoldSubtract } from 'design-system/icons/IconBoldSubtract';
import { SpaceUserAvatar } from 'design-system/SpaceUserAvatar';
import { isWeb } from '../../../constants';
/**
 * If you need to show this within a card, use `onCard`, which makes logo icons use darker background in dark mode.
 */
const RowPotAccount = ({ data, style, onCard, onPress, disabled, plusIcon = false, minusIcon = false, hideSpaceUserAvatar = false, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const editingSpace = plusIcon || minusIcon;
    const { primaryBalance, secondaryBalance } = getBalanceForPots(data);
    const handlePress = useCallback(() => {
        if (onPress) {
            onPress();
            return;
        }
        navigation.navigateDeprecated('Pot', { screenParams: data });
    }, [onPress, data]);
    return (<TouchableHighlight {...(!editingSpace && { hoverOnLight: true })} underlayColor={colors.background.underlay} activeOpacity={1} onPress={handlePress} disabled={(!editingSpace && isWeb) || disabled}>
      <View style={[styles.rowAccount, style]}>
        {plusIcon ? (<>
            <View style={styles.buttonContainer}>
              <IconBoldAdd color={colors.elements.positive}/>
            </View>
            <Spacer w={16}/>
          </>) : null}

        {minusIcon ? (<>
            <View style={styles.buttonContainer}>
              <IconBoldSubtract color={colors.elements.negative}/>
            </View>
            <Spacer w={16}/>
          </>) : null}
        <View style={[
            styles.container,
            onCard && styles.onCard, // in dark mode, when shown on a card, should have darker background
        ]}>
          <EmojiText>{data.emoji}</EmojiText>
        </View>
        <View style={styles.textContainer}>
          <Text Text-16 numberOfLines={1} ellipsizeMode="tail">
            {data.name}
          </Text>
          {!(hideSpaceUserAvatar || editingSpace) ? (<SpaceUserAvatar xxSmall spaceId={data.spaceId} userId={data.userId}/>) : null}
        </View>
        <View style={styles.amountContainer}>
          <Amount Numbers-16 value={primaryBalance}/>
          {!!secondaryBalance && (<Amount NumbersThin-14 Secondary value={secondaryBalance}/>)}
        </View>
      </View>
    </TouchableHighlight>);
};
const styleSet = createStyleSheets((colors) => ({
    rowAccount: {
        paddingTop: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
        paddingBottom: rem(16),
    },
    textContainer: {
        flex: 1,
        flexGrow: 1,
        justifyContent: 'center',
        paddingHorizontal: rem(16),
    },
    container: {
        alignItems: 'center',
        borderRadius: rem(22),
        width: rem(CIRCLE_SIZE),
        justifyContent: 'center',
        height: rem(CIRCLE_SIZE),
        backgroundColor: colors.cards.onLight,
    },
    onCard: {
        backgroundColor: colors.background.dark,
    },
    amountContainer: {
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    buttonContainer: {
        justifyContent: 'center',
    },
}));
export default RowPotAccount;
